import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  static targets = [
    'salesInSettlement',
    'sumSalesInSettlement',
    'missingTrades'
  ]
  static values = {
    sumOfTrades: Number,
    sumOfSales: Number
  }

  addVolume({ params: { volume, index } }) {
    this.salesInSettlementTargets[index].value = volume
    this.#setSumOfSales()
  }

  addSoldGos() {
    this.#setSumOfSales()
  }

  sumOfSalesValueChanged() {
    this.sumSalesInSettlementTarget.innerText = this.sumOfSalesValue
    this.missingTradesTarget.innerText =
      this.sumOfTradesValue - this.sumOfSalesValue
  }

  #setSumOfSales() {
    this.sumOfSalesValue = this.#sumRower(
      this.salesInSettlementTargets,
      'value'
    )
  }

  #sumRower(elements, key) {
    return elements.reduce((a, b) => a + parseInt(b[key]), 0)
  }
}
